// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/static/fonts/Objective-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../public/static/fonts/Objective-Medium.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body,
html {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}

.content-main-wrapper {
  overflow-x: hidden;
}
@font-face {
  font-family: "Objective-Bold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___})
    format("opentype");
  font-weight: 600;
  font-style: normal;
}
@font-face {
  font-family: "Objective-Medium";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___})
    format("opentype");
  font-weight: 500;
  font-style: normal;
}
@font-face {
  font-family: "Objective-Extra-Light";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___})
    format("opentype");
  font-weight: 400;
  font-style: normal;
}

.carousel-container {
  display: none;
}
.content-page {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.content-content {
  text-align: center;
  color: white;
  padding: 0px 20px 20px 20px;
  margin: 0 20px;
  border-radius: 10px;
  margin-top: -180px;
}

h1.content-content {
  font-size: 43px;
  margin-bottom: 5px;
  margin-top: 0;
  font-family: Objective-Bold;
  text-align: center;
}

.content-content h2 {
  font-size: 23px;
  margin-bottom: 5px;
  margin-top: 0;
  font-family: "Objective-Medium";
}

.content-content h3 {
  font-size: 15px;
  margin-bottom: -5px;
  margin-top: 0;
  font-family: "Objective-Light";
}

.content-dot-container-center {
  display: flex;
  justify-content: center;
  margin-top: -20px;
}
.content-dot-container {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  background-color: #d9d9d9;
  border-radius: 50px;
  width: 240px;
  height: 50px;
}

.content-dot {
  width: 16px;
  height: 16px;
  background-color: #ffffff;
  border-radius: 50%;
  margin: 17px 7px 10px 7px;
  transition: transform 0.3s ease;
}

.content-dot.content-activeSlide {
  transform: scale(1.5);
  background-color: #ffffff;
  border-radius: 50px;
  width: 23px;
  height: 14px;
}

/* Carousel container styling */
.carousel-slide {
  display: flex;
  justify-content: center; /* Centers horizontally */
  align-items: center; /* Centers vertically */
  height: 100%; /* Matches the height of the parent container */
  text-align: center; /* Ensures inner text is centered */
}

.carousel-content {
  background: rgba(0, 0, 0, 0.7); /* Semi-transparent background */
  color: white;
  border-radius: 10px;
  padding: 20px;
  text-align: center;
  max-width: 900px; /* Adjust width as needed */
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
  margin: auto; /* Ensures the element is aligned within its parent */
}

.carousel-content h2 {
  font-size: 34px;
  font-family: "Objective-Bold";
  margin-bottom: 10px;
}

.carousel-content h3 {
  font-size: 28px;
  font-family: "Objective-Light";
  margin-bottom: 10px;
}

.carousel-content p {
  font-size: 26px;
  font-family: "Objective-Medium";
  line-height: 1.5;
}

.carousel-content time {
  font-size: 24px;
  font-family: "Objective-Light";
  margin-top: 10px;
  display: block;
}

@media (max-width: 768px) {
  .content-main-wrapper {
    margin-top: -0px;
  }
  .content-page {
    margin-top: -140px;
    padding-bottom: 50px;
  }
  img.content-key-logo {
    min-width: 210px;
    max-width: 220px;
    margin-bottom: 10px;
    margin-top: 20px;
  }
  .content-content {
    padding: 20px;
    margin: 0 20px;
    border-radius: 10px;
    max-width: 700px;
    margin-left: 2vw;
    margin-top: 190px;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  .content-content h1 {
    font-size: 30px;
    margin-bottom: -5px;
    margin-top: 0;
    font-family: "Objective-Bold";
    text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.74); /* Add shadow */
  }

  .content-content h2 {
    font-size: 18px;
  }

  .content-content h3 {
    font-size: 12px;
    font-family: "Objective-Extra-Light";
  }

  .content-content p {
    margin-top: 20px;
    font-size: 18px;
    line-height: 1.5;
    font-family: "Objective-Extra-Light";
  }

  button.content-btn-download {
    position: absolute;
    font-size: 18px;
    width: 180px;
    padding: 20px 10px;
    margin-top: 0px;
    left: 50%;
    height: 55px;
    transform: translateX(-50%);
    display: block;
    bottom: 50px;
  }

  img.scrolldown-indicator-logo-content {
    width: 220px;
    bottom: 30px;
    left: 24%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Content/Content.css"],"names":[],"mappings":"AAAA;;EAEE,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B;sBACoB;EACpB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,+BAA+B;EAC/B;sBACoB;EACpB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,oCAAoC;EACpC;sBACoB;EACpB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,2BAA2B;EAC3B,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,uBAAuB,EAAE,yBAAyB;EAClD,mBAAmB,EAAE,uBAAuB;EAC5C,YAAY,EAAE,+CAA+C;EAC7D,kBAAkB,EAAE,mCAAmC;AACzD;;AAEA;EACE,8BAA8B,EAAE,gCAAgC;EAChE,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gBAAgB,EAAE,2BAA2B;EAC7C,wCAAwC;EACxC,YAAY,EAAE,qDAAqD;AACrE;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;EACA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,6BAA6B;IAC7B,4CAA4C,EAAE,eAAe;EAC/D;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,oCAAoC;EACtC;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,oCAAoC;EACtC;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,SAAS;IACT,YAAY;IACZ,2BAA2B;IAC3B,cAAc;IACd,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,SAAS;EACX;AACF","sourcesContent":["body,\nhtml {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.content-main-wrapper {\n  overflow-x: hidden;\n}\n@font-face {\n  font-family: \"Objective-Bold\";\n  src: url(\"../../../public/static/fonts/Objective-Light.otf\")\n    format(\"opentype\");\n  font-weight: 600;\n  font-style: normal;\n}\n@font-face {\n  font-family: \"Objective-Medium\";\n  src: url(\"../../../public/static/fonts/Objective-Medium.otf\")\n    format(\"opentype\");\n  font-weight: 500;\n  font-style: normal;\n}\n@font-face {\n  font-family: \"Objective-Extra-Light\";\n  src: url(\"../../../public/static/fonts/Objective-Light.otf\")\n    format(\"opentype\");\n  font-weight: 400;\n  font-style: normal;\n}\n\n.carousel-container {\n  display: none;\n}\n.content-page {\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.content-content {\n  text-align: center;\n  color: white;\n  padding: 0px 20px 20px 20px;\n  margin: 0 20px;\n  border-radius: 10px;\n  margin-top: -180px;\n}\n\nh1.content-content {\n  font-size: 43px;\n  margin-bottom: 5px;\n  margin-top: 0;\n  font-family: Objective-Bold;\n  text-align: center;\n}\n\n.content-content h2 {\n  font-size: 23px;\n  margin-bottom: 5px;\n  margin-top: 0;\n  font-family: \"Objective-Medium\";\n}\n\n.content-content h3 {\n  font-size: 15px;\n  margin-bottom: -5px;\n  margin-top: 0;\n  font-family: \"Objective-Light\";\n}\n\n.content-dot-container-center {\n  display: flex;\n  justify-content: center;\n  margin-top: -20px;\n}\n.content-dot-container {\n  display: flex;\n  justify-content: center;\n  margin-top: 20px;\n  background-color: #d9d9d9;\n  border-radius: 50px;\n  width: 240px;\n  height: 50px;\n}\n\n.content-dot {\n  width: 16px;\n  height: 16px;\n  background-color: #ffffff;\n  border-radius: 50%;\n  margin: 17px 7px 10px 7px;\n  transition: transform 0.3s ease;\n}\n\n.content-dot.content-activeSlide {\n  transform: scale(1.5);\n  background-color: #ffffff;\n  border-radius: 50px;\n  width: 23px;\n  height: 14px;\n}\n\n/* Carousel container styling */\n.carousel-slide {\n  display: flex;\n  justify-content: center; /* Centers horizontally */\n  align-items: center; /* Centers vertically */\n  height: 100%; /* Matches the height of the parent container */\n  text-align: center; /* Ensures inner text is centered */\n}\n\n.carousel-content {\n  background: rgba(0, 0, 0, 0.7); /* Semi-transparent background */\n  color: white;\n  border-radius: 10px;\n  padding: 20px;\n  text-align: center;\n  max-width: 900px; /* Adjust width as needed */\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);\n  margin: auto; /* Ensures the element is aligned within its parent */\n}\n\n.carousel-content h2 {\n  font-size: 34px;\n  font-family: \"Objective-Bold\";\n  margin-bottom: 10px;\n}\n\n.carousel-content h3 {\n  font-size: 28px;\n  font-family: \"Objective-Light\";\n  margin-bottom: 10px;\n}\n\n.carousel-content p {\n  font-size: 26px;\n  font-family: \"Objective-Medium\";\n  line-height: 1.5;\n}\n\n.carousel-content time {\n  font-size: 24px;\n  font-family: \"Objective-Light\";\n  margin-top: 10px;\n  display: block;\n}\n\n@media (max-width: 768px) {\n  .content-main-wrapper {\n    margin-top: -0px;\n  }\n  .content-page {\n    margin-top: -140px;\n    padding-bottom: 50px;\n  }\n  img.content-key-logo {\n    min-width: 210px;\n    max-width: 220px;\n    margin-bottom: 10px;\n    margin-top: 20px;\n  }\n  .content-content {\n    padding: 20px;\n    margin: 0 20px;\n    border-radius: 10px;\n    max-width: 700px;\n    margin-left: 2vw;\n    margin-top: 190px;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n  }\n\n  .content-content h1 {\n    font-size: 30px;\n    margin-bottom: -5px;\n    margin-top: 0;\n    font-family: \"Objective-Bold\";\n    text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.74); /* Add shadow */\n  }\n\n  .content-content h2 {\n    font-size: 18px;\n  }\n\n  .content-content h3 {\n    font-size: 12px;\n    font-family: \"Objective-Extra-Light\";\n  }\n\n  .content-content p {\n    margin-top: 20px;\n    font-size: 18px;\n    line-height: 1.5;\n    font-family: \"Objective-Extra-Light\";\n  }\n\n  button.content-btn-download {\n    position: absolute;\n    font-size: 18px;\n    width: 180px;\n    padding: 20px 10px;\n    margin-top: 0px;\n    left: 50%;\n    height: 55px;\n    transform: translateX(-50%);\n    display: block;\n    bottom: 50px;\n  }\n\n  img.scrolldown-indicator-logo-content {\n    width: 220px;\n    bottom: 30px;\n    left: 24%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
